// @flow

import React from 'react';
import type { Node } from 'react';
import { Markdown, TabAccordion, TabPane } from '@riseart/common';

type Props = {
  children?: Function,
  questions: Array<Object>,
  type?: string,
  onTabChange: Function,
  className?: string,
};

/**
 * CmsModuleFaqs
 *
 * @param {Props} props
 * @returns {Node}
 */
export function CmsModuleFaqs({
  type,
  className = null,
  onTabChange = null,
  questions = [],
}: Props): Node {
  const filteredQuestions = type ? questions.filter((item) => item.type === type) : questions;

  return filteredQuestions && filteredQuestions.length ? (
    <TabAccordion multiple scrollToActive={false} className={className} onTabChange={onTabChange}>
      {filteredQuestions.map(({ question, answer }, idx) => (
        <TabPane header={question} key={question || idx} tabId={`question_${idx + 1}`}>
          <Markdown text={answer} linkTarget="_blank" />
        </TabPane>
      ))}
    </TabAccordion>
  ) : null;
}
